<template>
  <div class="supplier-info">
    <div class="title">药品入库信息</div>
    <el-table :data="productList">
      <el-table-column prop="documentNo" label="单号" />
      <el-table-column prop="receivingUnit" label="供应商名称" />
      <el-table-column prop="productName" label="药品通用名称" />
      <el-table-column prop="approvalNumber" label="药品批准文号" />
      <el-table-column prop="batchNumber" label="生产批号" />
      <el-table-column
        prop="number"
        label="入库数量（最小包装单元）"
        width="180px"
      />
      <el-table-column prop="issuanceDate" label="入库时间" />
    </el-table>
  </div>
</template>

<script>
export default {
  props: ['productList']
};
</script>

<style lang="stylus" scoped>
.supplier-info
  border 1px solid #ccc
  padding 20px
  margin-bottom 20px
  .title
    font-size 16px
    text-align center
    color #000
    font-weight 700
    margin-bottom 20px
</style>
